<template>
    <div class="flex flex-col gap-10 items-center w-full">
        <div class="flex flex-col gap-4 w-full">
            <ButtonWrapper
                v-for="button in buttons"
                :key="button.key"
                class="w-full h-12"
                rounded-class="rounded-2.5"
                color="white"
                @click="button.action"
                ><component
                    :is="button.icon"
                    class="absolute"
                    :class="{
                        'left-5 h-4 w-4': button.key != 'email',
                        'left-4 h-6 w-6': button.key === 'email',
                    }"
                />
                <span> {{ button.label }}</span></ButtonWrapper
            >
        </div>
        <div class="p-3 pr-6">
            <ButtonWrapper
                class="text-white"
                color="transparent"
                text
                @click="handleReturnClick"
            >
                <div class="flex gap-2 items-center">
                    <ArrowLeftIcon class="h-4 w-4" />
                    {{ t("auth.pwa.ctas.social_logins.back") }}
                </div>
            </ButtonWrapper>
        </div>
    </div>
</template>
<script setup>
import ArrowLeftIcon from "@/Components/Icons/ArrowLeftIcon.vue";
import ButtonWrapper from "@/Components/Buttons/ButtonWrapper.vue";
import FacebookLogo from "@/Components/Icons/FacebookLogo.vue";
import GoogleLoginLogo from "@/Components/Icons/GoogleLoginLogo.vue";
import MailIcon from "@/Components/Icons/MailIcon.vue";
import { useI18n } from "vue-i18n";
import { loginWith } from "@/Helpers/socialLogin.js";
import { computed, markRaw } from "vue";

const props = defineProps({
    action: {
        type: String,
        default: null,
    },
});

const { t } = useI18n({ useScope: "global" });
const emit = defineEmits([
    "selected-social-login",
    "proceed-with-email",
    "reset-action",
]);
const handleSocialClick = (driver) => {
    if (props.action === "login") {
        loginWith(driver);

        return;
    }

    emit("selected-social-login", driver);
};
const handleEmailClick = () => {
    emit("proceed-with-email");
};
const handleReturnClick = () => {
    emit("reset-action");
};

const buttons = computed(() => {
    return [
        {
            key: "email",
            icon: markRaw(MailIcon),
            label: t("auth.pwa.ctas.social_logins.email"),
            action: () => handleEmailClick(),
        },
        {
            key: "google",
            icon: markRaw(GoogleLoginLogo),
            label: t("auth.pwa.ctas.social_logins.google"),
            action: () => handleSocialClick("google"),
        },
        {
            key: "facebook",
            icon: markRaw(FacebookLogo),
            label: t("auth.pwa.ctas.social_logins.facebook"),
            action: () => handleSocialClick("facebook"),
        },
    ];
});
</script>
